var map = {
	"./active-ring.svg": 12521,
	"./border.svg": 43994,
	"./button.svg": 3508,
	"./carousel.svg": 55398,
	"./clock.svg": 87666,
	"./column.svg": 97894,
	"./decoration.svg": 96458,
	"./digital-flop.svg": 22222,
	"./gauge.svg": 60513,
	"./iframe.svg": 14864,
	"./image.svg": 79095,
	"./line.svg": 84822,
	"./map-gc.svg": 60993,
	"./map-migrate.svg": 75470,
	"./num.svg": 31136,
	"./percent-pond.svg": 77729,
	"./pie.svg": 33462,
	"./rect-num.svg": 42933,
	"./scroll-list.svg": 97820,
	"./scroll-table.svg": 35272,
	"./td-column.svg": 63303,
	"./text.svg": 65669,
	"./water-level.svg": 27956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61412;